import { render, staticRenderFns } from "./PersonIdentification.vue?vue&type=template&id=264bf1d2&scoped=true"
import script from "./PersonIdentification.vue?vue&type=script&lang=js"
export * from "./PersonIdentification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264bf1d2",
  null
  
)

export default component.exports